import React, { useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { Row } from "react-bootstrap";
import TemplateCustomization from "./template-customization";
import TemplateDetails from "./template-details";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  resetSingleTemplateDetails,
  resetUpdateSingleTemplate,
  retrieveSingleTemplateDetails,
} from "../../../redux/actions/single-template";
import { setFallbackMessage } from "../../../redux/actions/universal";
import { sendErrorNotification } from "../../universal/notifications/notifications";
import "./style.scss";

const Index = (props) => {
  const dispatch = useDispatch();

  const history = useHistory();

  const templateId =
    props && props.match && props.match.params && props.match.params.id;
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const fetchError = useSelector(
    (state) => state.singleTemplate.fetchTemplate.error
  );
  const fetchLoading = useSelector(
    (state) => state.singleTemplate.fetchTemplate.loading
  );

  const updateStatus = useSelector(
    (state) => state.singleTemplate.updateTemplate.status
  );
  const updateError = useSelector(
    (state) => state.singleTemplate.updateTemplate.error
  );

  useEffect(() => {
    if (templateId && selectedCompany) {
      dispatch(
        retrieveSingleTemplateDetails({
          companyId: selectedCompany,
          templateId: templateId,
        })
      );
    }
  }, [templateId, selectedCompany]);

  useEffect(() => {
    if (!fetchLoading && fetchError) {
      dispatch(resetSingleTemplateDetails());
      dispatch(resetUpdateSingleTemplate());
      dispatch(
        setFallbackMessage({ type: "error", content: "Kunne ikke åpne mal." })
      );
      history.push("/dashboard/maler");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchError]);

  useEffect(() => {
    if (updateStatus) {
      dispatch(resetSingleTemplateDetails());
      dispatch(resetUpdateSingleTemplate());
      dispatch(
        setFallbackMessage({ type: "success", content: "Malen ble oppdatert" })
      );
      history.push("/dashboard/maler");
    }

    if (updateError) {
      sendErrorNotification("Kunne ikke oppdatere mal.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateStatus, updateError]);

  return (
    <section className="dashboard-single-template-section">
      <div className="inner-dashboard-single-template-container">
        <Row className="dashboard-single-template-row">
          <TemplateCustomization />
          <TemplateDetails />
        </Row>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(Index);
